const axios = require('axios');

const self = {};

self.authToken = 'keyGBgZJL6gpXiz5k';

self.initAxios = () => {
  const headers = self.authToken ? { Authorization: `Bearer ${self.authToken}` } : {};
  return axios.create({
    baseURL: 'https://api.airtable.com/v0/apph4MUYxo9ilSIN7/',
    headers,
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./src/utils/axios.js